/* src/app/views/dashboard/components/sidebar-nav/nav-item/products-nav-item/products-nav-item.component.scss */
/*# sourceMappingURL=products-nav-item.component.css.map */
